$(document).ready(function() {
	if(!document.querySelector('.GPC0164')) return false;
	var keyBenefitUI = {
		init : function(){
			keyBenefitUI.kbfSlick()
		},
		kbfSlick : function(){
			$('.has-item-4').each(function(){
				var sliderTarget = $(this);
				$(window).on('load resize orientationchange', function() {
					if(sliderTarget.find(".item").length > 4){
						var delay = 500;
						var timer = null;
						setTimeout(function() {
							clearTimeout(timer);
							if(sliderTarget.hasClass('slick-initialized') !== true){
								sliderTarget.slick({
									arrows: true, 
									dots: false,
									adaptiveHeight: true,
									infinite : false,
									slidesToShow: 4,
									slidesToScroll: 1,
									prevArrow: carouselOptions.squarePrev,
									nextArrow: carouselOptions.squareNext, 
									responsive: [
										{	
											breakpoint: 767,
											settings: "unslick"
										}
									]
								});
							}
						}, delay);
					} 
				});
			});
		}
	}
	keyBenefitUI.init()
});



			
			